module.exports = __webpack_public_path__ + "img/img2.a2b70325.jpg";